import axios from "axios";

const getAll = async () => {
    try {
        const response = await axios.get("/api/admin/users");
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

const getOne = async (id) => {
    try {
        const response = await axios.get("/api/admin/users/" + id);
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

const addOne = async (data) => {
    try {
        const response = await axios.post("/api/admin/users/", data);
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

const updateOne = async (id, data) => {
    try {
        const response = await axios.put("/api/admin/users/" + id, data);
        return response.data
    } catch (error) {
        return { error: error.response.data.message };
    }
}

export default {
    getAll,
    getOne,
    addOne,
    updateOne
}